export async function initPaytmCheckout() {
  return new Promise((resolve) => {
    window.Paytm.CheckoutJS.onLoad(resolve);
  });
};
